/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class t{constructor(t){this.disposers=new Map,this.updateObservers=()=>{for(const[t,s]of this.disposers)t(this.o,s)},void 0!==t&&(this.value=t)}get value(){return this.o}set value(t){this.setValue(t)}setValue(t,s=!1){const i=s||!Object.is(t,this.o);this.o=t,i&&this.updateObservers()}addCallback(t,s){if(s){this.disposers.has(t)||this.disposers.set(t,(()=>{this.disposers.delete(t)}));const s=this.disposers.get(t);t(this.value,s)}else t(this.value)}clearCallbacks(){this.disposers.clear()}}export{t as ValueNotifier};
//# sourceMappingURL=value-notifier.js.map
